import React from "react";
import Translations from "modules/translations";

const TranslationsPage = () => {
  return <Translations />;
};

export default TranslationsPage;
